import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appTemplate]',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {},
  standalone: true,
})
export class TemplateDirective {
  @Input() type: string | undefined;

  @Input('appTemplate') name: string | undefined;

  // eslint-disable-next-line no-useless-constructor, @typescript-eslint/no-explicit-any
  constructor(public template: TemplateRef<any>) {}

  getType(): string {
    return this.name!;
  }
}
